import { render } from "./Show.vue?vue&type=template&id=904357fa&scoped=true"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=904357fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-904357fa"

export default script